import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { findSeoPage, SITE_URL, structuredDataFor } from 'shared/config/seo';

function setMeta(key: string, content: string, property = false) {
    const attribute = property ? 'property' : 'name';
    let element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
    if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, key);
        document.head.appendChild(element);
    }
    element.content = content;
}

export const Seo = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        const page = findSeoPage(pathname);
        const title = page?.title || 'Страница не найдена — Ансар';
        const description = page?.description || 'Такой страницы нет. Перейдите к курсам школы программирования Ансар.';
        const url = SITE_URL + (page?.path || pathname);
        document.title = title;
        setMeta('description', description);
        setMeta('robots', page ? 'index, follow, max-image-preview:large' : 'noindex, follow');
        setMeta('og:title', title, true);
        setMeta('og:description', description, true);
        setMeta('og:url', url, true);
        setMeta('twitter:title', title);
        setMeta('twitter:description', description);
        setMeta('twitter:url', url);
        let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
        if (page) {
            if (!canonical) {
                canonical = document.createElement('link');
                canonical.rel = 'canonical';
                document.head.appendChild(canonical);
            }
            canonical.href = url;
        } else canonical?.remove();
        let schema = document.getElementById('site-schema');
        if (page) {
            if (!schema) {
                schema = document.createElement('script');
                schema.id = 'site-schema';
                schema.setAttribute('type', 'application/ld+json');
                document.head.appendChild(schema);
            }
            schema.textContent = JSON.stringify(structuredDataFor(page)).replace(/</g, '\\u003c');
        } else schema?.remove();
        document.documentElement.dataset.seoPath = page?.path || '/404';
    }, [pathname]);

    useEffect(() => {
        if (hash) {
            const id = decodeURIComponent(hash.slice(1));
            requestAnimationFrame(() => document.getElementById(id)?.scrollIntoView());
        } else window.scrollTo(0, 0);
    }, [pathname, hash]);
    return null;
};
